<!--
 * @description:
 * @author: cuicui
 * @Date: 2023-01-20 00:11:27
 * @LastEditTime: 2023-01-29 23:49:51
 * @LastEditors: cuicui
-->
<template functional>
  <div class="user-state-label-wrapper">
    <template v-if="props.status === $options.status().ENTRUST">
      <i class="el-icon-circle el-icon-time" style="background-color:#00bd83;"></i>
      <span style="color:#00bd83;">已委托其他律所</span>
    </template>
    <template v-else-if="props.status === $options.status().SUCCESS">
      <i class="el-icon-circle el-icon-circle-check" style="background-color:#005bff"></i>
      <span style="color:#005bff">已接受</span>
    </template>
    <template v-else-if="props.status === $options.status().ERROR">
      <i class="el-icon-circle el-icon-circle-close" style="background-color:#FF5753"></i>
      <span style="color:#FF5753">已拒绝</span>
    </template>
    <template v-else>
      <i class="el-icon-circle el-icon-remove-outline" style="background-color:#dadde0;"></i>
      <span style="color:#dadde0">未处理</span>
    </template>
  </div>
</template>

<script>
import { STATUS } from '../_eum';
export default {
  name: 'userStateLabel',
  props: {
    status: {
      type: String,
      required: true
    }
  },
  status() {
    return STATUS;
  }
};
</script>

<style lang="scss">
.user-state-label-wrapper {
  display: flex;
  align-items: center;
  // .state-label {
  //   height: 20px;
  //   width: 20px;
  //   padding: 2px;
  //   border-radius: 50%;
  //   line-height: 16px;
  i {
    margin-right: 9px;
  }
  // }
}
</style>
